import { Link } from "react-router-dom";
import ArrowRightIcon from "../../icons/arrowRightIcon";
import BoxOpenIcon from "../../icons/boxOpenIcon";
import CubeIcon from "../../icons/cubeIcon";
import CubesIcon from "../../icons/cubesIcon";
import { useTranslation } from "react-i18next";

const Containers = () => {
  const { t } = useTranslation();
  return (
    <article className="py-10 bg-white">
      <div className="relative z-10 flex flex-col items-center justify-center w-11/12 h-full gap-2 mx-auto lg:justify-between lg:flex-row ">
        <section className="order-2 space-y-4 lg:order-1">
          <h2 className="text-[32px] font-semibold text-mainBlue">
            {t("typesAndSizesOfContainers")}
          </h2>
          <div>
            <p className="flex items-center gap-2 text-lg font-medium">
              <BoxOpenIcon />
              <span>{t("openTop")}</span>
            </p>
          </div>
          <div>
            <p className="flex items-center gap-2 text-lg font-medium">
              <CubeIcon />
              <span>{t("20FT")}</span>
            </p>
          </div>
          <div>
            <p className="flex items-center gap-2 text-lg font-medium">
              <CubesIcon />
              <span>{t("40FT")}</span>
            </p>
          </div>

          <Link
            className="px-5  py-4 bg-mainRed rounded-lg text-white flex items-center gap-2 font-bold w-[230px] text-xl justify-center arrow-link"
            to="/container-sizes"
          >
            <span>{t("seeMore")}</span>
            <span className="rtl:rotate-180 arrow">
              <ArrowRightIcon fill={"white"} />
            </span>
          </Link>
        </section>
        <section className="order-1 lg:order-2">
          <img src="/assets/containers.png" alt="containers" />
        </section>
      </div>
    </article>
  );
};

export default Containers;
